import _sfc_main from "./BuyBoxShopperInsights2.mjs";
/* empty css                        */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxShopperInsight = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-483ca6ef"]]);
export {
  BuyBoxShopperInsight as default
};
//# sourceMappingURL=BuyBoxShopperInsights.mjs.map
